<template>
  <div class="quiz-result">
    <div class="intro mb-3">
      Twoje motto: „Honor jest najważniejszy”
    </div>

    <div class="cechy columns d-flex p-2">
      <div class="col-auto pt-3 images">
        <img :src="require('@/assets/images/segmentacja/thumb-norm-holderzy.jpg')"
             alt="group thumbnail"
             class="img-responsive"/>
      </div>
      <div class="pl-4 pl-sm-0 description-col">
        <img :src="require('@/assets/images/segmentacja/icon-norm-holderzy.png')"
             alt="group thumbnail"
             class="img-responsive mb-2 icon"/>
        <p>
          Rodzina jest dla Ciebie najważniejsza – starasz się ją budować,
          wychodząc z&nbsp;założenia, że wszystko powinno być na swoim miejscu -
          dzieci to dzieci, a&nbsp;rodzice to rodzice.
          Każdy ma swoje prawa i&nbsp;swoje obowiązki.
        </p>
        <p>
          Starszym należy się szacunek – dzieci powinny doceniać to, co się dla nich robi.
          Ważna jest historia rodziny i&nbsp;to, skąd ona pochodzi.
        </p>
        <p>
          Nie chcesz w&nbsp;swoim życiu pędzić do przodu.<br/>
          Wolisz mieć czas dla bliskich, ale i&nbsp;dla siebie i&nbsp;swoich zajawek.
        </p>
        <p>
          Przywiązanie do tradycji wcale nie oznacza bycia nudnym.
          Potrzebujesz jasnych wytycznych w&nbsp;zakresie zasad postępowania w&nbsp;życiu -
          jeżeli uznasz je za słuszne, jesteś im wierny i&nbsp;potrafisz ich bronić.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NormHolderzy',
};
</script>

<style scoped>
.intro {
  color: #FFFFFF;
  background: var(--color-norm-holderzy);
  font-size: 1.3em;
  font-weight: 700;
  padding: .6em .8em;
}
</style>
